import { takeLatest } from 'redux-saga/effects';
import { fetchMarginDelivery } from '../reducers/deliveriesReducer';
import generateSaga from '../utils/generateSaga';

export default function* watch() {
  yield takeLatest(fetchMarginDelivery, generateSaga(fetchMarginDelivery));
}
